var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import XHRUpload from "../../../../node_modules/.pnpm/@uppy_xhr-upload@4.3.3_@uppy_core@4.4.5/node_modules/@uppy/xhr-upload/lib/index.js";
import { useFileManagerCommon } from "./useFileManagerCommon.js";
import get from "../../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/get.js";
import isNil from "../../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js";
function useFileManager(files, fileInputRef, emits, options) {
  const {
    uppy,
    errorMessage,
    setErrorMessage,
    texts,
    isDragOver,
    isDragging,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleDragStart,
    handleDragEnd,
    uploadAreaDirection,
    handleSelectFile,
    handleFileChange,
    handleDeleteFile,
    handleDownloadFile,
    getFileKey,
    getIcon
  } = useFileManagerCommon(files, fileInputRef, emits, options);
  return uppy.use(XHRUpload, {
    endpoint: options.endpoint,
    headers: options.headers,
    timeout: options.timeout
  }), uppy.on("upload-success", (file, response) => {
    var _a;
    if (!files.value)
      return;
    const index = files.value.findIndex((f) => f.uid === (file == null ? void 0 : file.id));
    if (index !== -1) {
      files.value[index].status = "success";
      let extractedId = null;
      if (options.idField)
        if (typeof options.idField == "function")
          extractedId = options.idField(response == null ? void 0 : response.body);
        else {
          const value = get(response == null ? void 0 : response.body, options.idField);
          extractedId = typeof value == "string" ? value : isNil(value) ? null : String(value);
        }
      else {
        const defaultValue = (_a = response == null ? void 0 : response.body) == null ? void 0 : _a.data;
        extractedId = typeof defaultValue == "string" ? defaultValue : isNil(defaultValue) ? null : String(defaultValue);
      }
      files.value[index].id = extractedId, emits("success", files.value[index]);
    }
  }), {
    // 状态
    errorMessage,
    isDragOver,
    isDragging,
    uploadAreaDirection,
    // 文本和限制
    texts,
    // 方法
    handleSelectFile,
    handleFileChange,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleDeleteFile,
    getFileKey,
    getIcon,
    setErrorMessage,
    handleDragStart,
    handleDragEnd,
    handleDownloadFile
  };
}
__name(useFileManager, "useFileManager");
export {
  useFileManager
};
//# sourceMappingURL=useFileManager.js.map
